import { ONE_DAY_MS } from '../../domain/utils/date'
import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectVisitCount } from '../ui/ui.selectors'

const selectPushState = store => store?.push

export const selectHasAcceptedPush = createCustomSelector(selectPushState, push => push?.accepted ?? false)

export const selectPushLastDisplay = createCustomSelector(selectPushState, push => push?.timestamp ?? 0)

export const DELAY_BETWEEN_PUSH = ONE_DAY_MS * 7

export const selectShouldDisplayPush = createCustomSelector(
  selectHasAcceptedPush,
  selectPushLastDisplay,
  selectVisitCount,
  (hasAccepted, lastDisplay, visitCount) => {
    if (hasAccepted) return false
    const now = new Date().getTime()
    return visitCount > 2 && now - lastDisplay > DELAY_BETWEEN_PUSH
  }
)
